/** Backend experiment Name (kebab) — must equal the registry key and the seed `AbExperiment.Name`. */
export const METHOD_BADGE_EXPERIMENT = 'method-badge';
/** Treatment variant code — must equal the seeded `AbExperimentVariant.ExperimentCode`. */
export const BADGE_ON = 'badge-on';

/**
 * Gate: show a badge only under the treatment variant AND for a non-empty stored code.
 * Single source of truth for the render. `variant` is intentionally typed `string`
 * (not the narrow `VariantOf<'method-badge'>` union) so any unexpected/unknown
 * variant value safely returns false — keep this defensive.
 */
export const shouldShowMethodBadge = (variant: string, code?: string | null): boolean =>
  variant === BADGE_ON && !!code;
